import { Link } from 'react-router-dom'
import { User } from '../../lib/user'
import { Events } from '../../components/events/Events'

type Props = {
  user: User
  onJoinPPlus: () => void
}

export const Footer = ({user, onJoinPPlus}: Props) => {
  const footerLink = (href: string, text: string) => {
    return <Link to={href} className="p-1 sm:p-2 hover:underline dark:hover:text-indigo-500 text-indigo-900 dark:text-indigo-300 uppercase">
      {text}</Link>
  }
  return (
    <div className="flex flex-col justify-between">
    <div className="flex"></div>
    <div className="mt-4 flex justify-center items-center flex-col">
      <Events />
      <div className="text-xs sm:text-sm sm:p-2 flex items-center">
        {footerLink("/tos", "Terms of service")}
        <span className="dark:text-indigo-900">|</span>
        {footerLink("/privacy", "Privacy Policy")}
        <span className="dark:text-indigo-900">|</span>
        <a href={"mailto:grant.warman+polygonle@gmail.com"} className="p-2 hover:underline dark:hover:text-indigo-500 text-indigo-900 dark:text-indigo-300 uppercase">Contact</a>
      </div>
      <div className="p-2 mb-4 flex items-center">
        <p className="text-xs sm:text-sm dark:text-gray-400 text-gray-800">&copy; Polygonle LLC 2023. All rights reserved.</p>
      </div>
    </div>
  </div>
  )
}
